import React from 'react'
import styles from './DevelopedBy.module.scss'
import Flowminder from '../../../assets/img/Flowminder_Small.png'

const DevelopedBy = () => {

  return (
    <div className={styles.developedBy}>
      Developed by 
      <img className={styles.companyName}
        src={Flowminder}
        alt='Flowminder Logo'
      />
    </div>
  )
}

export default DevelopedBy
